import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import RoleServices from "services/RoleServices";
import { notifyError, notifySuccess } from "utils/toast";

const useRoleSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);

      const RoleData = {
        country_name: data.country_name,
        name:data.name,
       
      };

      if (id) {
        const res = await RoleServices.updateRole(id, RoleData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await RoleServices.addRole({ RoleData });
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getRoleData = async () => {
    try {
      const res = await RoleServices.getRoleById(id);
      if (res) {
        setValue("country_name", res.country_name);
        setValue("name",res.name);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("country_name");
      setValue("name");
      clearErrors("country_name");
      clearErrors("name");
      return;
    }
      
    if (id) {
      getRoleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    loading,
    setLoading,
    errors,
    isSubmitting,
  };
};

export default useRoleSubmit;
